<template>
  <span v-show="false"></span>
</template>
<script>
export default {
  name: 'LiveProductData',
  props: ['liveData'],
  data () {
    return {
      version: '0.0.2'
    }
  },
  created () {
    this.parseDataToStore()
  },
  methods: {
    parseDataToStore () {
      this.$store.dispatch('setLiveProductData', this.liveData)
    }
  }
}
</script>
